import React from 'react'
import './vipPurchase.css'
import Price_Tag from './priceTagPage'
import WeChat_Pay from '../imageSrc/weChat_pay.png'
import Close_Purchase from '../imageSrc/close_purchase.png'
import {fetchGet, fetchPost} from "../utils/fetchData";
import {convert_FormData_to_json2} from "../../config";
import {message} from "antd/lib/index";
import {showErrorMsg} from "../utils/commonFunc";

class Vip_Purchase extends React.Component {
    constructor(props) {
        super(props);
        this.vipId = null;
        this.timmer = null;
        this.state = {
            title:'会员尊享权益',
            intro:null,
            list:[],
            selectKey:0,
            picUrl:null,
            price:null,
        }
    }

    viewDidShow = () => {
        let data = fetchGet('memberIntro',null,null);
        data.then(data => {
            if (data.code === 200) {
                let model = {
                    title:null,
                    price:null,
                    intro:null,
                    vipid:null,
                };
                let listInfo = [];
                for (model in data.data.list) {
                    listInfo.push(data.data.list[model]);
                };
                this.setState({
                    title:data.data.title,
                    intro:data.data.intro,
                    list:listInfo,
                });
                this.vipId = listInfo[0].vipid;
                this.handleRequestBarCode(listInfo[0].vipid,0)
                this.setIntevalRequestPay();
            } else {
                this.showError(data.message);
            }
        })
    };

    setIntevalRequestPay = () => {
        this.timmer=setInterval(()=>{
            this.requestPayStatus();
        }, 3000)
    };

    requestPayStatus = () => {
        let formDataUpload = new FormData();
        formDataUpload.append("vipid", this.vipId);
        fetchPost('orderPayStatus',convert_FormData_to_json2(formDataUpload),null)
            .then(data => {
                if (data.code === 200) {
                    if (data.data.info === 'Done') {
                        if (this.timmer) {
                            clearInterval(this.timmer);
                            message.success('支付成功');
                            this.props.purchaseCallBack();
                        }
                    }
                }
                else {
                    showErrorMsg(data);
                }
            })
    };


    componentDidMount(){
        this.props.triggerRef(this);

    };

    handleClose = () => {
        clearInterval(this.timmer);
        this.props.closePage();
    };

    handleRequestBarCode = (vipid,key) => {
        this.vipId = vipid;
        this.setState({
            selectKey:key,
            price:this.state.list[key].price,
        });

        let formData = new FormData();
        formData.append("vipid",vipid);

        let retValue = fetchPost('buyMemberQR',convert_FormData_to_json2(formData),null);
        retValue.then(data => {
            if (data.code === 200) {
                this.setState({
                    picUrl:data.data.info,
                });
            } else {
                showErrorMsg(data);
            }
        })
    };

    render(){
        return(
            <div style={{display:this.props.visible?'inline-block':'none'}} className='div_purchase_frame'>
                <div className='div_purchase_content'>
                    <div className='purchse_top'>
                        <p className='title_style'>购买会员</p>
                        <img onClick={this.handleClose} src={Close_Purchase} style={{width:14 + 'px',height:14 + 'px',marginTop:12 + 'px',marginLeft:95+ '%'}}/>
                    </div>
                    <br/>
                    <span className='content_style topTitle'>会员尊享权益</span>
                    <br/>
                    <br/>
                    <p className='content_style_purchase auth'>{this.state.intro}</p>

                    <div>{
                        this.state.list.map((item, index) => {
                            let selected = false;
                            if (index === this.state.selectKey) {
                                selected = true;
                            }
                                return <Price_Tag key={index}
                                                  price={item.price}
                                                  vipType={item.title}
                                                  intro = {item.intro}
                                                  priceId = {item.vipid}
                                                  requestBarCode={this.handleRequestBarCode}
                                                  selected={selected}
                                                  index={index}
                                                 />
                            }
                        )
                    }

                    </div>

                    <p className='pay_type_text_style'>支付方式:</p>
                    <img style={{width:133.3 + 'px',height:45.6 + 'px',marginLeft:15 + 'px',display:'inline-block'}} src={WeChat_Pay}/>
                    <br/>
                    <p style={{display:'inline',marginLeft:42 + 'px'}}>支付金额:<span style={{color:'red',fontSize:18 + 'px'}}>{this.state.price}</span></p>

                    <img style={{marginLeft:244 + 'px',width:29.4 + '%',height:35 + '%'}} src={this.state.picUrl}/>

                </div>

            </div>
        );
    }
}

export default Vip_Purchase